import React from "react"
import { Outlet, useParams } from "react-router-dom"
import GuideProfileHeader from "pagesV2/pro/GuideProfile/GuideHeader"
import withDefaultErrorBoundary from "modules/errors/HOCs/withDefaultErrorBoundary"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"
import GuideNavigationTabs from "pagesV2/pro/GuideProfile/GuideNavigationTabs"
import { Flex, Button } from "antd"
import { useTranslation } from "react-i18next"
import { Title } from "ui/Typography"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { routes } from "router/routes"
import { getHostsByEnvironment } from "utils/host-urls"
import { Icon } from "ui/Icon"
import { toaster } from "components/common/Toast"

const ProGuideProfileLayout = () => {
  const guide = useSelector(modelSelector("guide"))
  const { t } = useTranslation()
  const { slug } = useParams()

  return (
    <main>
      <GuestHeader />
      <Flex gap={10} className="py-xl  container" align="center" justify="space-between">
        <Title level={4}>{t("guide.navigation.guide_profile")}</Title>
        <Button
          type="text"
          aria-label="Copy profile link"
          onClick={async () => {
            try {
              const { PROTOCOL, CUSTOMER } = getHostsByEnvironment()
              const path = routes.proGuideProfilePath({ slug })
              const url = `${PROTOCOL}${CUSTOMER}/#${path}`
              await navigator.clipboard.writeText(url)
              toaster.success(t("global.guide_profile_copied"))
            } catch (error) {
              toaster.error(error?.message || t("global.guide_profile_copy_failed"))
            }
          }}
          icon={<Icon type="feather" name="Copy" width={18} height={18} />}
          iconPosition="end"
        >
          {t("global.share_profile")}
        </Button>
      </Flex>

      <div className="container">
        <GuideProfileHeader guide={guide} />
        <GuideNavigationTabs slug={guide?.slug} />
      </div>
      <div>
        <DefaultErrorBoundary>
          <Outlet />
        </DefaultErrorBoundary>
      </div>
    </main>
  )
}

export default withDefaultErrorBoundary(ProGuideProfileLayout)
